export const CloseButton = ({ onClick }) => (
  <button className="btn-close btn--close--card btn-lg" onClick={onClick}>
    <i className="fa fa-times" />
  </button>
);
